import React from 'react';
import moment from 'moment';
import NumberSelector from './NumberSelector'

export default function TimeSelector(props) {
  const id = props.id || 'input-' + props.name;
  console.log('value', props.value);
  const date = props.value ? new Date(props.value): new Date(0);
  const handleHoursChange = (ev) => {
    date.setHours(ev.value);
    // const newValue = date.toISOString();
    const minutes = props.value ? props.value.split(':')[1] : '00';
    const newValue = moment(`${ev.value}:${minutes}`, 'H:mm').format('HH:mm');
    if (props.onChange) props.onChange({name: props.name, value: newValue});
    else console.log(props.name, newValue);
  }
  const handleMinutesChange = (ev) => {
    date.setMinutes(ev.value);
    // const newValue = date.toISOString();
    const hours = props.value ? props.value.split(':')[0] : '00';
    const newValue = moment(`${hours}:${ev.value}`, 'HH:m').format('HH:mm');
    if (props.onChange) props.onChange({name: props.name, value: newValue});
    else console.log(props.name, newValue);
  }
  const hoursSelectorProps = {
    id: 'select-' + props.name + '-hours',
    label: 'hours',
    name: props.name + '[hours]',
    // value: date.getHours(),
    value: props.value ? parseInt(props.value.split(':')[0]) : 0,
    min: 0,
    max: 23,
    onChange: handleHoursChange,
  };
  const minutesSelectorProps = {
    id: 'select-' + props.name + '-minutes',
    label: 'minutes',
    name: props.name + '[minutes]',
    // value: date.getMinutes(),
    value: props.value ? parseInt(props.value.split(':')[1]) : 0,
    min: 0,
    max: 59,
    increment: 5,
    onChange: handleMinutesChange,
  };
  //TODO add error message span
  return (
    <div className="col-sm-12">
      <div className="col-sm-3" style={{paddingLeft: 0}}>
        <NumberSelector {...hoursSelectorProps} />
      </div>
      <div className="col-sm-3" style={{paddingLeft: 0}}>
        <NumberSelector {...minutesSelectorProps} />
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ../hyperdb-utils/src/components/ui-react/TimeSelector.jsx